import { useEffect } from "react";
import PropTypes from "prop-types";

import installPendo from "./installPendo";

const Pendo = ({ apiKey, visitor, account }) => {
  useEffect(
    () => {
      const onLoad = () => {
        if (!window.pendo) {
          console.error("Pendo failed to load");
          return;
        }

        window.pendo.initialize({ visitor, account });
      };

      if (apiKey && visitor.id && account.id && !window.pendo) {
        installPendo(apiKey, onLoad);
      }
    },
    [apiKey, visitor, account]
  );

  return null;
};

Pendo.propTypes = {
  apiKey: PropTypes.string,
  visitor: PropTypes.shape({
    id: PropTypes.string,
    email: PropTypes.string,
    role: PropTypes.string
  }),
  account: PropTypes.shape({
    id: PropTypes.string
  })
};

export default Pendo;
